import { Entity } from '../entity.service';

export class Department extends Entity {
    type = 'departments';

    departmentId: string;
    description: string;
    state: string;
}
